import Request from './request'
import store from '@/store'
const SEV_BASE_URL = process.env.NODE_ENV === 'production' ? '' : '/sevapi'

export const userValid = async requestData => {
  return await Request({
    title: '获取sid状态',
    url: SEV_BASE_URL + '/api/as/user/valid',
    app: 'sev',
    data: requestData
  })
}
export const getOrderList = async requestData => {
  return await Request({
    title: '选择会员的订单-商品列表',
    url: SEV_BASE_URL + '/api/as/shop/orderList',
    app: 'sev',
    data: requestData
  })
}
export const getInfoByOrderItem = async requestData => {
  return await Request({
    title: '选择订单商品信息带入',
    url: SEV_BASE_URL + '/api/as/shop/getInfoByOrderItem',
    app: 'sev',
    data: requestData
  })
}
export const getJsapiSignature = async requestData => {
  return await Request({
    title: '获取小程序信息',
    url: SEV_BASE_URL + '/api/as/user/getJsapiSignature',
    method: 'post',
    app: 'sev',
    data: requestData
  })
}
export const getProductInfoBySn = async requestData => {
  return await Request({
    title: '根据sn查询订单产品',
    url: SEV_BASE_URL + '/api/as/shop/getProductInfoBySn',
    app: 'sev',
    data: requestData
  })
}
export const listReceiverInfo = async requestData => {
  return await Request({
    title: '地址列表',
    url: SEV_BASE_URL + '/api/as/receiver/listReceiverInfo',
    app: 'sev',
    data: requestData
  })
}
export const receiverInsert = async requestData => {
  return await Request({
    title: '新增地址',
    url: SEV_BASE_URL + '/api/as/receiver/insert',
    method: 'post',
    app: 'sev',
    data: requestData
  })
}
export const receiverDelete = async requestData => {
  return await Request({
    title: '删除地址',
    url: SEV_BASE_URL + '/api/as/receiver/delete',
    app: 'sev',
    data: requestData
  })
}
export const receiverUpdate = async requestData => {
  return await Request({
    title: '修改地址',
    url: SEV_BASE_URL + '/api/as/receiver/update',
    method: 'post',
    app: 'sev',
    data: requestData
  })
}
export const getReceiverInfoDetail = async requestData => {
  return await Request({
    title: '获取地址详情',
    url: SEV_BASE_URL + '/api/as/receiver/getReceiverInfoDetail',
    app: 'sev',
    data: requestData
  })
}
export const fileUpload = async requestData => {
  return await Request({
    title: '文件上传',
    url: SEV_BASE_URL + '/api/as/file/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 300000,
    data: requestData,
    app: 'sev'
  })
}
export const getDictData = async requestData => {
  return await Request({
    title: '通用字典接口',
    url: SEV_BASE_URL + '/api/as/dict/data/queryByType',
    app: 'sev',
    data: requestData
  })
}

export const ticketSave = async requestData => {
  return await Request({
    title: '服务单保存',
    url: SEV_BASE_URL + '/api/as/service/ticket/save',
    app: 'sev',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: requestData
  })
}

export const getServiceList = async requestData => {
  return await Request({
    title: '我的服务单-服务单列表查询',
    url: SEV_BASE_URL + '/api/as/service/ticket/page',
    app: 'sev',
    data: requestData
  })
}

export const getServiceDetail = async requestData => {
  return await Request({
    title: '我的服务单-服务单详情',
    url: SEV_BASE_URL + '/api/as/service/ticket/detail',
    app: 'sev',
    data: requestData
  })
}

export const operateServiceTicket = async requestData => {
  return await Request({
    title: '我的服务单-取消服务单',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    url: SEV_BASE_URL + '/api/as/serviceTicket/operate/operate',
    app: 'sev',
    data: requestData
  })
}

export const getServiceTicketProgressList = async requestData => {
  return await Request({
    title: '我的服务单-查询服务单历程',
    url: SEV_BASE_URL + '/api/as/serviceTicket/operate/getServiceTicketProgressList',
    app: 'sev',
    data: requestData
  })
}

export const serviceEvaluateInfo = async requestData => {
  return await Request({
    title: '我的服务单-获取评价详情',
    url: SEV_BASE_URL + '/api/as/service/evaluate/info',
    data: requestData
  })
}

export const serviceEvaluateDoevaluate = async requestData => {
  return await Request({
    title: '我的服务单-评价-表单提交',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    url: SEV_BASE_URL + '/api/as/service/evaluate/doevaluate',
    data: requestData
  })
}

export const getRatesList = async requestData => {
  return await Request({
    title: '收费标准',
    method: 'post',
    url: SEV_BASE_URL + '/api/as/service/charge/standard/queryChargeStandardNameList',
    data: requestData
  })
}

export const getQueryCostDetail = async requestData => {
  return await Request({
    title: '收费标准-查询产品品类对应的各项费用',
    method: 'post',
    url: SEV_BASE_URL + '/api/as/service/charge/standard/queryCostDetail',
    data: requestData
  })
}

export const trackingPage = async requestData => {
  return await Request({
    title: '页面事件上报',
    url: SEV_BASE_URL + '/api/as/trackingPage/insert',
    method: 'post',
    headers: {
      sid: store.state?.sev?.sid //需要携带sid，用于和账号关联
    },
    data: requestData
  })
}

export const trackingEvent = async requestData => {
  return await Request({
    title: '事件上报',
    url: SEV_BASE_URL + '/api/as/trackingEvent/insert',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      sid: store.state?.sev?.sid //需要携带sid，用于和账号关联
    },
    data: requestData
  })
}
